import React, { Component } from 'react';
import {
  Grid, TextField, Typography, Paper, Chip,
  Stepper, Step, StepLabel, StepContent,
  Dialog, DialogContent, DialogActions,
  List, ListItem, ListItemText, ListItemSecondaryAction,
  IconButton, Divider
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AppBarModal from '../general/AppBarModal';
import TareasTerminadas from '../general/TareasTerminadas';
import { BtnForm, BtnDetalle } from '../general/BotonesAccion';
import CustomDropzone from '../general/CustomDropzone';
import { api, consulta, formulario, mostrarError, coloresEmma } from '../../global/js/funciones';
import emma_w from '../../global/imagenes/emma_w.png';
import moment from 'moment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

const styles = theme => ({
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  chipEstado: {
    marginBottom: theme.spacing(1),
  },
  stepActivo: {
    color: '#009688',
  },
  seccionTitulo: {
    fontWeight: 600,
    borderBottom: '2px solid #e0e0e0',
    paddingBottom: 4,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  docItem: {
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    marginBottom: 4,
  },
});

const coloresEstado = {
  'Est_Consul_Env': '#757575',
  'Est_Consul_Pro': '#009688',
  'Est_Consul_Fin': '#0d47a1',
  'Est_Consul_Rech': '#b71c1c',
  'Est_Consul_Asig': '#9315b8',
  'Est_Consul_Reg': '#d34c1c',
  'Est_Consul_Subsa': '#009933',
  'Est_Consul_Correg': '#25F803',
};

class TrazabilidadConsultoria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      identificacion: '',
      radicado: '',
      casos: [],
      cargando: false,
      error: '',
      // modal carga documento
      modalCarga: false,
      casoSeleccionado: null,
      archivos: [],
      cargandoDoc: false,
    };
  }

  onChange = ({ target }) => this.setState({ [target.name]: target.value });

  consultar = () => {
    let { identificacion, radicado } = this.state;
    if (!identificacion && !radicado) {
      this.setState({ error: 'Ingrese su número de identificación o radicado.' });
      return;
    }
    this.setState({ error: '', casos: [], cargando: true });
    const params = radicado ? `radicado=${radicado}` : `identificacion=${identificacion}`;
    consulta(`api/v1.0/consultoria/trazabilidad/consultar?${params}`, null, null,
      (error, estado, resp) => {
        this.setState({ cargando: false });
        if (!error && estado === 200) {
          this.setState({ casos: resp });
        } else {
          this.setState({ error: resp?.titulo || 'No se encontraron casos asociados.' });
        }
      }
    );
  };

  abrirModalCarga = (caso) => {
    this.setState({ modalCarga: true, casoSeleccionado: caso, archivos: [] });
  };

  cerrarModalCarga = () => {
    this.setState({ modalCarga: false, casoSeleccionado: null, archivos: [] });
  };

  agregarArchivos = (arc) => {
    let { archivos } = this.state;
    this.setState({ archivos: archivos.concat(arc) });
  };

  eliminarArchivo = (i) => {
    let { archivos } = this.state;
    archivos.splice(i, 1);
    this.setState({ archivos: [...archivos] });
  };

  cargarDocumento = () => {
    let { archivos, casoSeleccionado, identificacion } = this.state;
    if (!archivos.length) return;
    this.setState({ cargandoDoc: true });
    const data = new FormData();
    data.append('radicado', String(casoSeleccionado.radicado).replace('SC-', ''));
    data.append('identificacion', identificacion);
    data.append('total', archivos.length);
    archivos.forEach((f, i) => data.append(`archivo${i}`, f));
    formulario('api/v1.0/consultoria/trazabilidad/cargar-documento', data, 'post',
      (error, estado, resp) => {
        this.setState({ cargandoDoc: false });
        if (!error && estado === 200) {
          this.cerrarModalCarga();
          this.consultar();
        }
      }, false
    );
  };

  pintarStepper(actuaciones) {
    if (!actuaciones || actuaciones.length === 0) {
      return <Typography variant="body2" color="textSecondary">Sin actuaciones registradas.</Typography>;
    }
    const activeStep = actuaciones.length - 1;
    return (
      <Stepper activeStep={activeStep} orientation="vertical" style={{ padding: '8px 0', background: 'transparent' }}>
        {actuaciones.map((act, i) => {
          const color = coloresEstado[act.tipo_estado__codigo] || '#757575';
          const esUltimo = i === activeStep;
          return (
            <Step key={i} completed={!esUltimo} active={esUltimo}>
              <StepLabel
                StepIconComponent={() =>
                  esUltimo
                    ? <CheckCircleIcon style={{ color, fontSize: 24 }} />
                    : <RadioButtonUncheckedIcon style={{ color: '#bdbdbd', fontSize: 24 }} />
                }
              >
                <Typography variant="body2" style={{ fontWeight: esUltimo ? 700 : 400, color: esUltimo ? color : 'inherit' }}>
                  {act['tipo_estado__nombre']}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {moment(act.fecha_registro).format('YYYY-MM-DD, h:mm a')}
                </Typography>
              </StepLabel>
              {act.observaciones && (
                <StepContent>
                  <Typography variant="body2" color="textSecondary">{act.observaciones}</Typography>
                </StepContent>
              )}
            </Step>
          );
        })}
      </Stepper>
    );
  }

  pintarDocumentos(documentos) {
    const { classes } = this.props;
    if (!documentos || documentos.length === 0) {
      return <Typography variant="body2" color="textSecondary">Sin documentos en el expediente.</Typography>;
    }
    return (
      <List dense disablePadding>
        {documentos.map((doc, i) => (
          <React.Fragment key={i}>
            <ListItem className={classes.docItem}>
              <ListItemText
                primary={doc.nombre_archivo}
                secondary={`${doc['requisito__nombre'] || 'Documento'} | ${moment(doc.fecha_registro).format('YYYY-MM-DD')}`}
              />
              <ListItemSecondaryAction>
                <a href={`${api}/media/${doc.archivo}`} target="_blank" rel="noopener noreferrer" className="sin_decorador">
                  <BtnDetalle callback={() => {}} color="#01579b" texto="Descargar" />
                </a>
              </ListItemSecondaryAction>
            </ListItem>
            {i < documentos.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    );
  }

  render() {
    const { classes } = this.props;
    const { identificacion, radicado, casos, cargando, error, modalCarga, archivos, cargandoDoc } = this.state;

    return (
      <div style={{ padding: '2%' }}>
        {/* Búsqueda */}
        <Paper className={classes.paper}>
          <Typography variant="h6" gutterBottom style={{ borderRadius: 50, backgroundColor: coloresEmma.secondarycolor, color: 'white', padding: '2%', textAlign: 'center' }}>Consulta de Trazabilidad</Typography>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} md={5}>
              <TextField
                label="Número de identificación"
                name="identificacion"
                value={identificacion}
                onChange={this.onChange}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                label="Radicado (ej: 123)"
                name="radicado"
                value={radicado}
                onChange={this.onChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <BtnForm texto="CONSULTAR" callback={this.consultar} />
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Typography color="error" variant="body2">{error}</Typography>
              </Grid>
            )}
          </Grid>
        </Paper>

        {/* Cargando */}
        {cargando && <TareasTerminadas mensaje="Consultando..." marginTop="5%" imagen={emma_w} widthImg="7%" cargando={true} />}

        {/* Resultados */}
        {casos.map((caso, idx) => (
          <Paper key={idx} className={classes.paper}>
            {/* Encabezado del caso */}
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6">Radicado: {caso.radicado}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Periodo: {caso.periodo} | Fecha: {moment(caso.fecha_registro).format('YYYY-MM-DD')}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} style={{ textAlign: 'right' }}>
                <Chip
                  label={caso.estado_actual}
                  className={classes.chipEstado}
                  style={{ backgroundColor: coloresEstado[caso.estado_actual_codigo] || '#757575', color: 'white' }}
                />
                {caso.area && <Chip label={`Área: ${caso.area}`} style={{ marginLeft: 4 }} />}
              </Grid>
            </Grid>

            <Divider style={{ margin: '12px 0' }} />

            {/* Stepper de actuaciones */}
            <Typography variant="subtitle2" className={classes.seccionTitulo}>
              Línea de tiempo del caso
            </Typography>
            {this.pintarStepper(caso.actuaciones)}

            <Divider style={{ margin: '12px 0' }} />

            {/* Documentos del expediente */}
            <Typography variant="subtitle2" className={classes.seccionTitulo}>
              Documentos del expediente
            </Typography>
            {this.pintarDocumentos(caso.documentos)}

            {/* Botón cargar documento */}
            <div style={{ marginTop: 12 }}>
              <BtnForm texto="APORTAR DOCUMENTO" callback={() => this.abrirModalCarga(caso)} />
            </div>
          </Paper>
        ))}

        {/* Modal carga de documento */}
        <Dialog fullWidth maxWidth="sm" open={modalCarga} onClose={this.cerrarModalCarga}>
          <AppBarModal
            titulo="Aportar documento al expediente"
            mostrarModal={this.cerrarModalCarga}
            titulo_accion="Cerrar"
            accion={this.cerrarModalCarga}
          />
          <DialogContent className="scroll">
            {cargandoDoc
              ? <TareasTerminadas mensaje="Cargando documento..." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />
              : <CustomDropzone
                  archivos={archivos}
                  addFunction={this.agregarArchivos}
                  deleteFunction={this.eliminarArchivo}
                  actualizarMensaje={() => {}}
                />
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={this.cerrarModalCarga} />
            {!cargandoDoc && <BtnForm texto="GUARDAR" callback={this.cargarDocumento} />}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(TrazabilidadConsultoria);
